import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';

const Sidebar = ({ currentView, onViewChange, isSidebarOpen }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard'},
    { id: 'candidatos', label: 'Candidatos'},
    { id: 'empresas', label: 'Empresas'},
    { id: 'ofertas', label: 'Ofertas de trabajo'},
    { id: 'usuarios', label: 'Usuarios'},
  ];

  return (
    <>
    <div className="bg-white border-end d-flex flex-column position-fixed" style={{ width: '280px', height: '100vh', zIndex: 100, left: isSidebarOpen ? '0' : '-280px', }}>
        <div className="p-4 border-bottom d-flex align-items-center justify-content-between">
          <div>
            <h6 className="mb-0 fw-bold text-uppercase text-muted small">Panel de</h6>
            <h5 className="mb-0 fw-bold">Administrador</h5>
          </div>
        </div>
        <Nav vertical className="flex-grow-1 p-3">
          {menuItems.map((item) => (
            <NavItem key={item.id} className="mb-2">
              <NavLink
                href="#"
                onClick={() => onViewChange(item.id)}
                className={`rounded-3 py-3 px-4 d-flex align-items-center gap-3 border-0 ${currentView === item.id
                    ? 'bg-dark text-white'
                    : 'bg-light text-dark'}`}
              >
                <span>{item.label}</span>
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      </div></>
  );
};

export default Sidebar;